module.exports = __webpack_public_path__ + "static/about_certyfikaty-d87c7d920f7ec4b8f04967d7e302c149.jpg";